// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"459354a8","256":"03958ab7","276":"d610ab6d","338":"e483a251","453":"0d33789e"}[chunkId] + ".chunk.js";
};